// Tiny DOM helpers. Avoid a framework for a project this small.

// Attributes whose value is an enumerated string ("true"/"false"), NOT a
// boolean. Assigning the DOM property is unreliable for these — `spellcheck`
// silently did nothing here for `false` (skipped as "omit") and would flip to
// true if passed the string 'false' — so always write the attribute directly.
const ENUMERATED_ATTRS = new Set(['spellcheck', 'draggable', 'contenteditable', 'translate']);

export function el(tag, props = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (v == null) continue;
    if (ENUMERATED_ATTRS.has(k)) { node.setAttribute(k, String(v)); continue; }
    // `false` means "omit" for plain attributes.
    if (v === false && !(k in node)) continue;
    if (k === 'class') node.className = v;
    else if (k === 'style' && typeof v === 'object') Object.assign(node.style, v);
    else if (k === 'dataset') Object.assign(node.dataset, v);
    else if (k.startsWith('on') && typeof v === 'function') node.addEventListener(k.slice(2).toLowerCase(), v);
    else if (k in node) node[k] = v;
    else node.setAttribute(k, v);
  }
  for (const child of [].concat(children)) {
    if (child == null || child === false) continue;
    node.append(child instanceof Node ? child : document.createTextNode(String(child)));
  }
  return node;
}

export function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }
